import Faqs from 'collections/Faqs';
import FaqSections from 'collections/FaqSections';
import { ActionTypes } from 'constants/FaqConstants';
import { dispatcher } from 'lib/Dispatcher';

const SECTIONS_PAGE_SIZE = 30;

const FaqActions = {
  loadFaqSections(page: number = 1, perPage: number = SECTIONS_PAGE_SIZE) {
    return FaqSections.fetch({
      page,
      per_page: perPage,
    }).then((response) => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_FAQ_SECTIONS,
        requested: perPage,
        sections: response,
      });
    });
  },

  loadFaqs(query: string, locale: string = 'en-US') {
    return Faqs.fetch(query, locale).then((response) => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_FAQS,
        faqs: response,
      });
      return response;
    });
  },
};

export default FaqActions;
